import React, { useState } from "react";
import { Typography, Button, Box } from "@mui/material";

const ExpandableTypography = ({ children, chunkSize = 100 }) => {
  const isText = typeof children === "string";
  const [visibleChars, setVisibleChars] = useState(chunkSize);

  const fullText = isText ? children : "";
  const isCollapsed = visibleChars < fullText.length;
  const showToggle = isText && fullText.length > chunkSize;

  const handleToggle = () => {
    setVisibleChars((prev) => {
      if (prev >= fullText.length) {
        return chunkSize; // collapse
      } else {
        return Math.min(prev + chunkSize, fullText.length); // expand more
      }
    });
  };

  const visibleText = isText ? fullText.slice(0, visibleChars) : children;
  const shouldEllipsis = isCollapsed;

  return (
    <>
      <Typography
        variant="body1"
        color="default.light"
        sx={{ whiteSpace: "pre-line", display: "inline" }}
      >
        {visibleText}
        {shouldEllipsis && "..."}
      </Typography>

      {showToggle && (
        <Box component="span" sx={{ ml: 1 }}>
          <Button
            onClick={handleToggle}
            size="small"
            sx={{ p: 0, textTransform: "none", minWidth: "auto" }}
          >
            {isCollapsed ? "View More" : "View Less"}
          </Button>
        </Box>
      )}
    </>
  );
};

export default ExpandableTypography;
